<template>
  <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogVisible">
    <el-form ref="form" :inline="false" :model="form" :rules="rules">
      <el-form-item label="" prop="value">
        <BjInput
          v-model="form.value"
          type="textarea"
          :placeholder="$t('OrdinaryOrderMix.SuspendReason.Suspend')"
          :maxlength="MAX_LENGTH.REMARK"
          show-word-limit
          clearable
          rows="5"
          required
        ></BjInput>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirmEditRemarks">{{ $t('okText') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { orderApi } from '@/api';
export default {
  name: 'BusinessOrderInternalViewFormSuspendReason',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: null,
    },
    info: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      // 弹窗显示
      dialogVisible: false,

      form: {
        value: null,
      },
    };
  },
  computed: {
    // 表单校验
    rules() {
      return {
        value: [{ required: false, message: this.$t('OrdinaryOrderMix.SuspendReason.Please') + this.title, trigger: 'blur' }],
      };
    },
  },
  methods: {
    onEdit(flag) {
      if (!flag) {
        // 解挂
        this.$confirm(this.$t('OrdinaryOrderMix.SuspendReason.continue'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            this.orderUnHandUpApi({ id: this.id });
          })
          .catch(() => {});
        return;
      }
      this.form = Object.assign({}, this.info);
      this.dialogVisible = true;
    },
    confirmEditRemarks() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.orderHandUpApi({
            id: this.id,
            suspendReason: this.form.value,
          });
        } else {
          return false;
        }
      });
    },
    // 订单级-挂起
    orderHandUpApi(POST_DATA) {
      orderApi.suspendOrderByOrderId(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    // 订单级-解挂
    orderUnHandUpApi(POST_DATA) {
      orderApi.unsuspendOrderByOrderId(POST_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.msgSuccess(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.reFresh();
          }, 500);
        }
      });
    },
    reFresh() {
      this.dialogVisible = false;
      this.$emit('reFresh');
    },
  },
};
</script>
